export default "__VITE_ASSET__e2d99a48__"